const WORDS = [
  'NorCal',
  'Co‑opcore',
  'Sproulian',
  'Sather‑pilled',
  'Bearish',
  'Telegraphy',
  'Doe‑dweller',
  'Glade‑coded',
  'RSF‑adjacent',
  'Unit‑3‑feral',
  'FoMoFo',
  'Boba‑brained',
  'Late‑night‑Gypsy',
  'Crosswalk‑defiant',
  'Blue‑and‑Gold',
  'Cal‑chaotic',
  'Berkeleyan',
  'Bay‑breezy',
  'Fog‑flirt',
  'Eco‑maximalist',
  'STEMlord',
  'Humcore',
  'Rhetorician',
  'Econ‑bro',
  'Pre‑Haas',
  'Haasified',
  'CS‑gremlin',
  'Data‑driven',
  'Bio‑curious',
  'CogSci‑coded',
  'Astro‑dreamer',
  'Mathlete',
  'Chem‑feral',
  'PoliSci‑spicy',
  'Philosophy‑pensive',
  'Linguist‑y',
  'Statistically‑inclined',
  'Lab‑goblin',
  'Research‑pilled',
  'GSI‑adjacent',
  'Chaotic',
  'Spicy',
  'Unhinged',
  'Tender',
  'Zesty',
  'Crunchy',
  'Whimsical',
  'Ferocious',
  'Cozy',
  'Snarky',
  'Feral',
  'Bougie',
  'Softcore',
  'Brainy',
  'Dreamy',
  'Mischief',
  'Radiant',
  'Spunky',
  'Goofy',
  'Iconic',
  'Compostable',
  'Solar‑powered',
  'Hyper‑local',
  'Organic',
  'Fair‑trade',
  'Thrift‑coded',
  'Co‑op‑feral',
  'Bike‑brained',
  'Protest‑ready',
  'Union‑pilled',
  'Ethical‑ish',
  'Overcaffeinated',
  'Yerba‑fueled',
  'Napping‑optional',
  'Lecture‑allergic',
  'Discussion‑flirty',
  'Office‑hours‑coded',
  'Midterm‑delusional',
  'Finals‑fermented',
  'Pass/No‑Pass‑pilled',
  'Situationship‑prone',
  'Flirtcore',
  'Snuggly',
  'Vibey',
  'Magnetic',
  'Playful',
  'Bold',
  'Tender‑chaos',
  'Mischief‑coded',
  'Soft‑chaotic',
  'Unbothered',
  'Zany',
  'Bewitching',
  'Spicy‑sweet',
  'Cozy‑chaos',
  'Flirtatious',
  'Dream‑coded',
  'Sparkly',
  'Legendary',
  'Icon‑adjacent',
];

export function getRandomWord() {
  return WORDS[Math.floor(Math.random() * WORDS.length)];
}

export default WORDS;
